<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">资产信息</div> -->
    <div class="div-top">
      <el-date-picker
        style="width: 300px; margin-left: 10px"
        v-model="searchData"
        value-format="yyyy-MM-dd"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >

      <el-button
        type="warning"
        @click="handleExport"
        style="margin-left: 10px"
        icon="el-icon-download"
        >导出数据</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
      >
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column
          label="处置年月"
          width="160"
          align="center"
          prop="iYearMonth"
          sortable
        ></el-table-column>
        <el-table-column
          label="处置类型"
          width="160"
          align="center"
          prop="ScrapTypeName"
          sortable
        ></el-table-column>
        <el-table-column
          label="资产分类"
          width="160"
          align="center"
          prop="AssetCategory"
          sortable
        ></el-table-column>
        <el-table-column
          label="原值"
          width="160"
          align="right"
          prop="OriginalValue"
          sortable
        >
          <template slot-scope="scope">
            {{ $tools.momenyFormat(scope.row.OriginalValue, 2) }}
          </template>
        </el-table-column>
        <el-table-column
          label="评估后值"
          align="right"
          prop="EvaluationValue"
          sortable
        >
          <template slot-scope="scope">
            {{ $tools.momenyFormat(scope.row.EvaluationValue, 2) }}
          </template>
        </el-table-column>
        <el-table-column label="净值" align="right" prop="NetValue" sortable>
          <template slot-scope="scope">
            {{ $tools.momenyFormat(scope.row.NetValue, 2) }}
          </template>
        </el-table-column>
        <el-table-column label="残值" align="right" prop="NetSalvage" sortable>
          <template slot-scope="scope">
            {{ $tools.momenyFormat(scope.row.NetSalvage, 2) }}
          </template>
        </el-table-column>
        <el-table-column
          label="处置收入"
          align="right"
          prop="NonOperatingIncome"
          sortable
        >
          <template slot-scope="scope">
            {{ $tools.momenyFormat(scope.row.NonOperatingIncome, 2) }}
          </template>
        </el-table-column>
        <el-table-column
          label="清理费用"
          align="right"
          prop="CleaningUpCost"
          sortable
        >
          <template slot-scope="scope">
            {{ $tools.momenyFormat(scope.row.CleaningUpCost, 2) }}
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
export default {
  data() {
    return {
      tools,
      moment,
      searchData: [],
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: {},
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.searchData = [firstDay, lastDay]
      }
    },
    handleExport() {
      tools.download(
        this.$rootUrl +
          `/AM/AM_AssetDisposal/ExportToExcel?searchData=${
            this.searchData?.length > 0 ? this.searchData.join(',') : ''
          }&Type=${this.AssetTreeSeacrh}`,
        '处置统计',
        '.xlsx',
        'get'
      )
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/AM/AM_AssetDisposal/GetAssetDisposalDTOList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'iYearMonth',
          SortType: 'Desc',
          Search: {
            Condition: 'searchData',
            Keyword:
              this.searchData?.length > 0 ? this.searchData.join(',') : '',
            Type: this.AssetTreeSeacrh || '',
          },
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['AssetTreeSeacrh']),
  },
  watch: {
    AssetTreeSeacrh() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
